import { z } from "zod";

export const loginInput = z.object({
  passcode: z.string().min(1).max(200),
});
export type LoginInput = z.infer<typeof loginInput>;

export const loginResponse = z.object({
  token: z.string(),
  /** Unix seconds when the JWT expires. */
  expiresAt: z.number().int(),
});
export type LoginResponse = z.infer<typeof loginResponse>;

/** Decoded JWT payload for the single admin. */
export const adminClaims = z.object({
  sub: z.literal("admin"),
  iat: z.number().int(),
  exp: z.number().int(),
});
export type AdminClaims = z.infer<typeof adminClaims>;

export const meResponse = z.object({
  authenticated: z.literal(true),
  sub: z.literal("admin"),
});
export type MeResponse = z.infer<typeof meResponse>;
